import { render } from "./AddTrack.vue?vue&type=template&id=c378bbe6"
import script from "./AddTrack.vue?vue&type=script&lang=js"
export * from "./AddTrack.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/menejar/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__